// extracted by mini-css-extract-plugin
module.exports = {"userSummaryContainer":"styles_userSummaryContainer__3c71m","fadeIn":"styles_fadeIn__2vell","userSummaryAvatar":"styles_userSummaryAvatar__2a45o"};